/**
 * ============================================================================
 *  SITE CONFIGURATION
 * ----------------------------------------------------------------------------
 *  Edit the values below to rebrand this template. These are the main knobs
 *  used across the app (header, footer, SEO, contact, payment page, etc.).
 * ============================================================================
 */

export const siteConfig = {
  brand: {
    name: 'USDT Flasher Store',
    tagline: 'USDT Flasher Store — Buy Flash USDT Software Online',
    description:
      'USDT Flasher Store is the online store for licensed flash USDT software. Multi-chain (TRC-20, ERC-20, BEP-20), 50+ compatible wallets, 24/7 support, and flash validity up to 365 days.',
  },

  domain: 'https://usdtflasherstore.com',

  contact: {
    orderEmail: 'buyflashusdtsoftware@gmail.com',
    supportEmail: 'buyflashusdtsoftware@gmail.com',
    whatsapp: '447514003077',
    phoneDisplay: '+44 7514 003077',
  },

  social: {
    twitter: 'https://twitter.com/yourbrand',
    facebook: 'https://facebook.com/yourbrand',
    instagram: 'https://instagram.com/yourbrand',
    telegram: 'https://t.me/yourbrand',
  },

  payment: {
    wallets: {
      bitcoin: 'bc1qlw4lcq87ue7l4tgn3m3j4ax7q2287hn5jgefqt',
      usdt: 'TNudmjRuhw29EMfVn7RHf2uEf8Lw9ePRFF',
    },
  },
};

export default siteConfig;
